import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent {
  constructor(private router: Router) {}

  goHome() {
    // Adjust route if your landing page path differs
    localStorage.clear(); // Clear any stored authentication tokens or user data
    this.router.navigate(['/']);

  }
}
